import type { UserSession } from 'nuxt-oidc-auth/runtime/types.js';

export const manageOrganizations = defineAbility(
  (user: UserSession, organizationId: string) => {
    if (
      ((user.userInfo?.permissions ?? []) as string[]).includes(
        'manage:namespaces:world',
      )
    ) {
      return true;
    }

    // TODO(DCG): Cleanup after the transition to manage:namespaces:group.
    return (
      ((user.userInfo?.permissions ?? []) as string[]).some((userPermission) =>
        // TODO: We might want to create a specific permission for org management but, for now, we
        // share it with group namespaces management.
        ['manage:namespaces:group', 'manage:organizations'].includes(
          userPermission,
        ),
      ) && organizationId === user.userInfo?.org_id
    );
  },
);

export const manageProjects = defineAbility(
  (user: UserSession, ownerId: string, projectNamespaceId: string) => {
    if (
      ((user.userInfo?.permissions ?? []) as string[]).includes(
        'manage:projects:world',
      )
    ) {
      return true;
    }

    //if share-projects flag is enabled, check if the user belongs to the project's namespace
    if (user.userInfo?.shareProjectsFlag) {
      return user.userInfo?.namespaceId === projectNamespaceId;
    }
    //else, only the owner who belongs to the project's namespace can manage the project
    return (
      ownerId === user.userInfo?.sub &&
      user.userInfo?.namespaceId === projectNamespaceId
    );
  },
);

export const manageNamespaces = defineAbility(
  (user: UserSession, namespaceId: string) => {
    if (
      ((user.userInfo?.permissions ?? []) as string[]).includes(
        'manage:namespaces:world',
      )
    ) {
      return true;
    }

    return user.userInfo?.namespaceId === namespaceId;
  },
);
export const createProjects = manageNamespaces;
export const listNamespaceProjects = manageNamespaces;

export const readUsages = defineAbility(
  (user: UserSession, ownerId: string) => {
    if (user.userInfo?.sub === ownerId) {
      return true;
    }

    const permissions = (user.userInfo?.permissions ?? []) as string[];

    if (permissions.includes('manage:namespaces:world')) {
      return true;
    }

    return false;
  },
);

export const manageInvoices = defineAbility((user: UserSession) => {
  return ((user.userInfo?.permissions ?? []) as string[]).includes(
    'manage:namespaces:world',
  );
});

export const deleteProjects = defineAbility(
  (user: UserSession, ownerId: string, projectNamespaceId: string) => {
    if (
      ((user.userInfo?.permissions ?? []) as string[]).includes(
        'manage:namespaces:world',
      ) ||
      (((user.userInfo?.permissions ?? []) as string[]).includes(
        'manage:namespaces:group',
      ) &&
        user.userInfo?.namespaceId === projectNamespaceId)
    ) {
      return true;
    }

    return (
      ownerId === user.userInfo?.sub &&
      user.userInfo?.namespaceId === projectNamespaceId
    );
  },
);
